// import enquire from "enquire-js/index";
import { debounce } from 'throttle-debounce';
import easydropdown from "easydropdown";
import mmenulight from 'mmenu-light';
import MobileDetect from 'mobile-detect';
import 'parsleyjs'


global.live = function live (eventType, elementQuerySelector, cb) {
	document.addEventListener(eventType, function (event) {
		var qs = document.querySelectorAll(elementQuerySelector);
		if (qs) {
			var el = event.target, index = -1;
			while (el && ((index = Array.prototype.indexOf.call(qs, el)) === -1)) {
				el = el.parentElement;
			}
			if (index > -1) {
				cb.call(el, event);
			}
		}

	});
}

let Core = {

	init: () => {
		Core.config();
		Core.tabbedContent();
		Core.accordions();
		Core.iframeResize();
		Core.customSelect();
		Core.copyValue();
		Core.mobileMenu();
		Core.scrollToAnchor();
		Core.showVideo();
		//Core.regionTrigger();
		Core.passwordToggler();
		Core.sideMenuNested();
		Core.getSticky();
		Core.eecLinks();
	},
	config: () => {
		numbro.registerLanguage({
			languageTag: "en-GB",
			delimiters: {
				thousands: ".",
				decimal: ","
			},
			abbreviations: {
				thousand: "k",
				million: "m",
				billion: "b",
				trillion: "t"
			},
			ordinal: (number) => {
				return number === 1 ? "" : "";
			},
			currency: {
				symbol: "€",
				position: "postfix",
				code: "EUR"
			},
			currencyFormat: {
				thousandSeparated: true,
				mantissa: 2,
				spaceSeparated: true,
				average: false
			},
			formats: {
				fourDigits: {
					totalLength: 4,
					spaceSeparated: true,
					average: true
				},
				fullWithTwoDecimals: {
					output: "currency",
					mantissa: 2,
					spaceSeparated: true,
					thousandSeparated: true
				},
				fullWithTwoDecimalsNoCurrency: {
					mantissa: 2,
					thousandSeparated: true
				},
				fullWithNoDecimals: {
					output: "currency",
					spaceSeparated: true,
					thousandSeparated: true,
					mantissa: 0
				}
			}
		});

		numbro.registerLanguage({
			languageTag: "en-US",
			delimiters: {
				thousands: ".",
				decimal: ","
			},
			abbreviations: {
				thousand: "k",
				million: "m",
				billion: "b",
				trillion: "t"
			},
			ordinal: (number) => {
				return number === 1 ? "" : "";
			},
			currency: {
				symbol: "$",
				position: "prefix",
				code: "USD"
			},
			currencyFormat: {
				thousandSeparated: true,
				mantissa: 2,
				spaceSeparated: false,
				average: false
			},
			formats: {
				fourDigits: {
					totalLength: 4,
					spaceSeparated: true,
					average: true
				},
				fullWithTwoDecimals: {
					output: "currency",
					mantissa: 2,
					spaceSeparated: true,
					thousandSeparated: true
				},
				fullWithTwoDecimalsNoCurrency: {
					mantissa: 2,
					thousandSeparated: true
				},
				fullWithNoDecimals: {
					output: "currency",
					spaceSeparated: true,
					thousandSeparated: true,
					mantissa: 0
				}
			}
		});
		const region_options = {
			Europe: 'en-GB',
			US: 'en-US'
		};
		//console.log('regija '+region_options[region]);
		numbro.setLanguage(region_options[region]);
	},

	tabbedContent: () => {

		live('click', '.buttons-wrapper > a', function(e) {
			e.preventDefault();

			var myTabs = document.querySelectorAll(".buttons-wrapper > a");
			for (var i = 0; i < myTabs.length; i++) {
				myTabs[i].classList.remove("active");
			}

			var _this = this;
			var href = _this.getAttribute('href');
			_this.classList.add('active');

			var tabsContent = document.querySelectorAll(".tab-content");

			for (i = 0; i < tabsContent.length; i++) {
				tabsContent[i].classList.remove("active");
			}

			var anchorReference = e.target;
			var activePaneId = anchorReference.getAttribute("href");
			var activePane = document.querySelector(activePaneId);

			activePane.classList.add("active");

			let additionalInfo = document.querySelector('.page-product--single-content');
			if (additionalInfo) {
				const yOffset = -84;
				const y = additionalInfo.getBoundingClientRect().top + window.scrollY + yOffset;
				window.scrollTo({top: y, behavior: 'smooth'});
			}

			function iframeSize(elements) {
				var iframes = document.querySelectorAll(elements);
				for( var i = 0; i < iframes.length; i++) {
					iframes[i].setAttribute('width', '100%');

					var videoWidth = iframes[i].offsetWidth;
					var videoHeight = (videoWidth / 16) * 9;
					iframes[i].setAttribute('height', videoHeight);
				}
			}

			iframeSize('.content--iframe iframe');
			window.onresize = debounce(200, () => {
				iframeSize('.content--iframe iframe');
			});

		});
	},

	accordions: () => {
		live('click', '.accordion-title', function(e) {
			this.classList.toggle("active");
			var panel = this.nextElementSibling;
			if (panel.style.maxHeight) {
				panel.style.maxHeight = null;
			} else {
				panel.style.maxHeight = panel.scrollHeight + "px";
			}
			if (this.parentElement.id !== undefined && history.pushState) {
				history.pushState(null, null, '#' + this.parentElement.id);
			}
		});

		live('click', '.cell-row.open button', function(e) {
			this.classList.toggle("active");
			const targetData = this.getAttribute('data-item');
			const targetElement = document.querySelector('[data-target="' + targetData + '"]');
			if (targetElement.style.maxHeight) {
				targetElement.style.maxHeight = null;
				targetElement.classList.remove('active');
			} else {
				targetElement.style.maxHeight = targetElement.scrollHeight + "px";
				targetElement.classList.add('active');
			}
		});
	},

	iframeResize: () => {
		function iframeSize(elements) {
			var iframes = document.querySelectorAll(elements);
			for( var i = 0; i < iframes.length; i++) {
				iframes[i].setAttribute('width', '100%');

				var videoWidth = iframes[i].offsetWidth;
				var videoHeight = (videoWidth / 16) * 9;
				iframes[i].setAttribute('height', videoHeight);
			}
		}

		iframeSize('.accordion-element iframe');
		window.onresize = debounce(200, () => {
			iframeSize('.accordion-element iframe');
		});
	},

	customSelect: () => {
		// TODO: Make custom select work everywhere from one call
		// var faqForm = document.getElementById('faqform');
		// if(typeof(faqForm) != 'undefined' && faqForm != null){
		// 	const faqSelect = easydropdown(faqForm);
		// }
	},

	copyValue: () => {
		live('click', '.btn-copy', function(e) {
			const urlValue = this.previousElementSibling;
			urlValue.select();
			urlValue.setSelectionRange(0, 99999);

			document.execCommand("copy");
			alert('Copied text: ' + urlValue.value);
		});
	},

	mobileMenu: () => {
		const menu = new MmenuLight(
			document.querySelector( "#menu-mobile" ),
			"(max-width: 991px)"
		);

		const navigator = menu.navigation({
			// options
		});

		const drawer = menu.offcanvas({
			// options
		});

		document.addEventListener(
			"DOMContentLoaded", () => {
				document.querySelector( "#hamburger" )
				.addEventListener( "click", ( event ) => {
					event.preventDefault();
					drawer.open();
				});

				const horizontal_menu = document.querySelector('.shop-menu .active')
				const sidebar_element = document.querySelector('.sidebar');
				if (horizontal_menu && sidebar_element) {
					sidebar_element.scrollLeft = horizontal_menu.getBoundingClientRect().left
				}
			}
		);
	},

	scrollToAnchor: () => {
		function animate(elem, style, unit, from, to, time, prop) {
			if (!elem) {
				return;
			}
			var start = new Date().getTime(),
				timer = setInterval(function () {
					var step = Math.min(1, (new Date().getTime() - start) / time);
					if (prop) {
						elem[style] = (from + step * (to - from))+unit;
					} else {
						elem.style[style] = (from + step * (to - from))+unit;
					}
					if (step === 1) {
						clearInterval(timer);
					}
				}, 25);
			if (prop) {
				elem[style] = from+unit;
			} else {
				elem.style[style] = from+unit;
			}
		}

		var simulateClick = function (elem) {
			// Create our event (with options)
			var evt = new MouseEvent('click', {
				bubbles: true,
				cancelable: true,
				view: window
			});
			// If cancelled, don't dispatch our event
			var canceled = !elem.dispatchEvent(evt);
		};

		if (location.hash) {
			console.log('scrolling')
			setTimeout(function() {
				window.scrollTo(0, 0);
			}, 1);

			window.onload = function () {
				const x = location.hash;
				const anchor = document.querySelector(x);
				const click = document.querySelector(x + ' button');
				const offset = anchor.getBoundingClientRect().top - 85
				simulateClick(click);
				animate(document.scrollingElement || document.documentElement, "scrollTop", "", 0, offset, 300, true);

			};
		}
	},

	showVideo: () => {
		var md = new MobileDetect(window.navigator.userAgent);

		if(md.mobile() === null) {
			var sources = document.querySelectorAll('video.video source');
			var video = document.querySelectorAll('video.video');
			for(var i = 0; i<sources.length;i++) {
				sources[i].setAttribute('src', sources[i].getAttribute('data-src'));
				video[i].load();
			}
		}
	},

	regionTrigger: () => {
		live('click', '.region .trigger', function() {
			this.classList.toggle('active');
			this.nextElementSibling.classList.toggle('active');
		});
	},

	passwordToggler: () => {
		live('click', '.password-toggle', function(e) {
			e.preventDefault();
			if( this.innerHTML == 'Show' ) {
				this.innerHTML = 'Hide'
				this.classList.add('hide');
				this.nextElementSibling.type="text";
			} else {
				this.innerHTML = 'Show'
				this.classList.remove('hide');
				this.nextElementSibling.type="password";
			}
		});
	},

	sideMenuNested: () => {
		live('click', '.sidebar .btn-toggle', function(e) {
			e.preventDefault();
			this.parentNode.classList.toggle("active");
			var submenu = this.parentNode.nextElementSibling;
			if (submenu.style.maxHeight) {
				submenu.style.maxHeight = null;
			} else {
				submenu.style.maxHeight = submenu.scrollHeight + "px";
			}
		});
	},

	getSticky: () => {
		window.addEventListener('scroll',(event) => {
			var buttons = document.querySelector('.tab-buttons');
			let additionalInfo = document.querySelector('#additional-info')

			if (buttons) {

				var distance = buttons.getBoundingClientRect().top;

				if((window.matchMedia("(min-width: 769px)").matches && distance <= 85) && additionalInfo && (additionalInfo.getBoundingClientRect().top > -(additionalInfo.clientHeight - 150))) {
					buttons.classList.add('sticky')
					buttons.classList.remove('sticky-hidden')
				} else if (window.matchMedia("(min-width: 769px)").matches && additionalInfo && (additionalInfo.getBoundingClientRect().top < -(additionalInfo.clientHeight - 150))) {
					buttons.classList.add('sticky', 'sticky-hidden');
				} else {
					buttons.classList.remove('sticky', 'sticky-hidden');
				}
			}
		});
	},

	eecLinks: () => {
		live('click', '*[data-eec-select-item]', function(e) {
			const payload = JSON.parse(e.target.dataset.eecSelectItem)

			window.dataLayer.push({'event_params': null, 'ecommerce': null})
			window.dataLayer.push({
				'event': 'RO_event_EEC',
				'event_params': {
					'gtm_name': 'EEC_select_item',
				},
				'ecommerce': {
					'currency': global.current_currency,
					'items': [payload].map(item => {
						Object.keys(item).forEach(attribute => {
							if (item[attribute] === 'undefined') {
								item[attribute] = undefined
							}
						})
						return item
					})
				}
			})
		})

		live('click', '*[data-eec-select-promotion]', function(e) {
			const product = JSON.parse(e.target.dataset.eecSelectPromotion)

			let creativeName = undefined
			if (product.picture) {
				const picture = product.picture.split("/")
				creativeName = picture[picture.length - 1]
			}
			const category = product.category.parent_category ? product.category.parent_category.title : product.category.title
			const subcategory = !product.category.parent_category ? undefined : product.category.title
			const productPrice = product.locale_price.price || product.price

			window.dataLayer.push({'event_params': null, 'ecommerce': null})
			window.dataLayer.push({
				'event': 'RO_event_EEC',
				'event_params': {
					'gtm_name': 'EEC_select_promotion',
				},
				'ecommerce': {
					'currency': global.current_currency,
					'location_id': e.target.dataset.eecSelectPromotionLocation,
					'promotion_name': e.target.dataset.eecSelectPromotionName,
					'promotion_id': product.id,
					'creative_name': creativeName,
					'creative_slot': e.target.dataset.eecSelectPromotionSlot,
					'items': [{
						'item_id': product.id,
						'item_name': product.title,
						'item_variant': undefined,
						'item_brand': 'Lupit Pole',
						'item_category': category,
						'item_category2': subcategory,
						'price': product.price_discount > 0 ? (productPrice - productPrice * (parseFloat(product.price_discount) / 100)) : productPrice,
						'discount': productPrice * (parseFloat(product.price_discount) / 100),
						'affiliation': e.target.dataset.eecSelectPromotionAffiliate ? e.target.dataset.eecSelectPromotionAffiliate : undefined
					}]
				}
			})
		})
	}
};
Core.init();
global.Core = Core;

window.Parsley.addAsyncValidator('vat', function (xhr) {
	let isEuCountryElement = document.getElementById('partner_billing_country');
	let isEuCountry = isEuCountryElement.options[isEuCountryElement.selectedIndex].getAttribute('data-is-eu');

	let isTaxPayer = document.getElementById('partner_company_is_taxpayer').checked;

	if (!isTaxPayer || !isEuCountry) {
		return true;
	}

	const response = JSON.parse(xhr.responseText);

	if (404 === xhr.status) {
		throw new Error('Network response was not ok');
	}

	return response.isValid;
}, '/validate-vat-number?vat={value}')

// Profile
live('change', '#profiletype', function(e) {
	if (e.target.value === 'b2c') {
		document.getElementById('b2b-reseller').classList.remove('active-tab');
	} else {
		document.getElementById('b2b-reseller').classList.add('active-tab');
	}
});

// Same partner checkbox
live('change', '#partner_same_owner', (e) => {
	document.getElementById('extra-owner-info').classList.toggle('d-none', e.target.checked)
})

// Countries' states
live('change', 'select[data-linked]', (e) => {
	// Get states
	const states = JSON.parse(e.target.querySelector('option:checked').dataset.states || null) || []
	// Get states element
	const statesSelect = document.querySelector(`.${e.target.dataset.linked}`)

	if (states.length > 0) {
		// Add empty option
		statesSelect.querySelector('select').innerHTML = '<option value=""></option>'
		for (let item in states) {
			let opt = document.createElement('option');
			opt.value = states[item].title;
			opt.innerHTML = states[item].title;
			statesSelect.querySelector('select').appendChild(opt)
		}
	} else {
		// Clear options
		statesSelect.querySelector('select').innerHTML = '<option value="">-</option>'
		statesSelect.querySelector('select').selectedIndex = 0
	}
	// Toggle visibility
	statesSelect.classList.toggle('d-none', states.length === 0)
})

// Profile form
live('submit', 'form[name="profile-form"]', (e) => {
	e.preventDefault();
	$(e.target).parsley({
		errorClass: 'is-invalid',
		excluded: ':disabled,:hidden,:hidden:not(.hideinput)',
		errorsWrapper: '<div class="invalid-feedback d-block"></div>',
		errorTemplate: '<span></span>',
		errorsContainer: function(el) {
			return el.$element.siblings('.errors');
		}
	}).whenValidate().done(() => {
		return e.target.submit();
	});
})

// Registration form
live('submit', 'form[name="registration-form"]', (e) => {
	e.preventDefault();
	if (!$(e.target).parsley({
		errorClass: 'is-invalid',
		excluded: ':disabled,:hidden,:hidden:not(.hideinput)',
		errorsWrapper: '<div class="invalid-feedback d-block"></div>',
		errorTemplate: '<span></span>',
		errorsContainer: function(el) {
			return el.$element.siblings('.errors');
		}
	}).validate()) {
		return false;
	}
	return e.target.submit();
})

live('submit', 'form[name="claim-form"]', (e) => {
	e.preventDefault();
	if (!$(e.target).parsley({
		errorClass: 'is-invalid',
		excluded: ':disabled,:hidden,:hidden:not(.hideinput)',
		errorsWrapper: '<div class="invalid-feedback d-block"></div>',
		errorTemplate: '<span></span>',
		errorsContainer: function(el) {
			return el.$element.siblings('.errors');
		}
	}).validate()) {
		return false;
	}
	return e.target.submit();
})
